import { Button } from 'react-bootstrap';
import { joinClasses } from 'utils/componentStyles/style.utils';

const WeatherMapPlaybackSpeedControl = ({
  speeds = [],
  value,
  onChange,
  disabled = false,
  ariaLabel,
  className,
  buttonClassName,
}) => (
  <div
    className={joinClasses('d-flex flex-wrap gap-1', className)}
    role="group"
    aria-label={ariaLabel}
  >
    {speeds.map((speed) => (
      <Button
        key={speed}
        variant={value === speed ? 'primary' : 'outline-secondary'}
        size="sm"
        className={joinClasses('flex-shrink-0', buttonClassName)}
        onClick={() => onChange?.(speed)}
        disabled={disabled}
        aria-pressed={value === speed}
      >
        {`${speed}x`}
      </Button>
    ))}
  </div>
);

export default WeatherMapPlaybackSpeedControl;
